// ============================================
// セッション管理 — Supabase Auth single source of truth
// sessionStorage 依存を廃止。認証状態は Supabase Auth のみ。
// ============================================
import { supabase } from '../supabase'
import { deleteCachedStaff } from '../localStore/appState' // D-268b FIX_C9
import { clearSentryUser } from '../sentry' // D-461 ITEM_2: ログアウト時に Sentry の利用者を外す(認証層は sentry ラッパ経由)
import { clearSessionActivity } from './sessionActivity' // D-838 FIX_B: 離席時刻はセッションと一緒に終わらせる

// ── Supabase Auth Session (single source of truth) ──

export async function getAuthSession() {
  const { data: { session } } = await supabase.auth.getSession()
  return session
}

export function extractMeta(session) {
  if (!session) return { staffId: null, staffName: '', staffRole: 'staff', staffStoreCode: null, accessToken: null }
  const meta = session.user?.user_metadata || {}
  return {
    staffId: meta.staff_id || null,
    staffName: meta.name || '',
    staffRole: meta.role || 'staff',
    staffStoreCode: meta.store_code || null,
    accessToken: session.access_token,
  }
}

// SPEC-COLLECTION-OFFLINE-COMPLETE-01 (D-268b) FIX_C9: 自発的ログアウト時にキャッシュ職員情報を削除する。
//   以後、キャッシュ無しでの session=null は「ログアウト済み」、キャッシュ有りは「不本意な失効(圏外継続対象)」と区別する。
//   これが無いとログアウトしたのに圏外継続で入れてしまう。
export async function logout() {
  // D-461 ITEM_2: 明示ログアウト(Launcher)とアイドルタイムアウト(useIdleLogout doLogout)は
  //   どちらも本関数を通るため、ここで一度だけ clearSentryUser を呼べば両経路をカバーする(共有端末で
  //   前の利用者を後続イベントに残さない)。setUser(null) は同期・例外を投げないので signOut 前でよい。
  clearSentryUser()
  // SPEC-LOGIN-BOUNCE-AFTER-SUCCESS-01 (D-838) FIX_B: 離席時刻はセッションに属する。
  //   ★セッションを終わらせる全経路がここを通るので、消すのはこの 1 点でよい
  //     (Launcher の明示ログアウト / useIdleLogout の doLogout / 今後増える経路)。
  //   消し忘れた古い時刻が次のログインに持ち越されると、ログイン直後に「30 分放置」と
  //   誤判定されて /login へ押し戻される。それが D-838 の症状そのものだった。
  clearSessionActivity()
  try { await deleteCachedStaff() } catch { /* 削除失敗は signOut を止めない */ }
  await supabase.auth.signOut()
}
